// Thin wrapper around Google Identity Services (GIS) — the only module that
// touches its script or the `google` global. Everything downstream works
// with a plain { idToken, email } pair, same as any other sign-in method.

const SCRIPT_SRC = 'https://accounts.google.com/gsi/client';

let scriptPromise = null;

// Loads the GIS script once per page; every later call reuses the same
// promise instead of injecting a second <script> tag.
export function loadGoogleIdentity() {
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    if (window.google?.accounts?.id) {
      resolve(window.google);
      return;
    }
    const script = document.createElement('script');
    script.src = SCRIPT_SRC;
    script.async = true;
    script.onload = () => resolve(window.google);
    script.onerror = () => reject(new Error('google_identity_load_failed'));
    document.head.appendChild(script);
  });
  return scriptPromise;
}

// The ID token's payload, read without checking its signature — that check
// happens server-side via GoogleAuthProvider.credential. This only decides
// which tenant to ask Firebase for, before Firebase is told anything.
export function emailFromIdToken(idToken) {
  const payload = idToken.split('.')[1];
  const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
  // JWT segments carry no padding; atob requires a length that is a multiple
  // of 4 in some engines (jsdom included), so it has to be restored here.
  const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
  const json = decodeURIComponent(
    Array.from(atob(padded))
      .map(char => '%' + char.charCodeAt(0).toString(16).padStart(2, '0'))
      .join(''),
  );
  return JSON.parse(json).email;
}
